export default {
    HEADER: 'Kompanija',
    PLACEHOLDER_NAME: 'Unesite naziv kompanije',
    LABEL_NAME: 'Naziv kompanije',
    LABEL_COMPANY_OWNER: 'Vlasnik',
    PLACEHOLDER_COUNTRY: 'Unesite državu',
    LABEL_COUNTRY: 'Država',
    PLACEHOLDER_STREET: 'Unesite ulicu',
    LABEL_STREET: 'Ulica',
    PLACEHOLDER_STREET_NUMBER: 'Unesite broj',
    LABEL_STREET_NUMBER: 'Broj',
    PLACEHOLDER_CITY: 'Unesite grad',
    LABEL_CITY: 'Grad',
    PLACEHOLDER_ZIP_CODE: 'Unesite poštanski broj',
    LABEL_ZIP_CODE: 'Poštanski broj',
    PLACEHOLDER_FLOOR: 'Unesite sprat',
    LABEL_FLOOR: 'Sprat',
    PLACEHOLDER_APARTMENT: 'Unesite apartman',
    LABEL_APARTMENT: 'Apartman',
    PLACEHOLDER_VAT_NUMBER: 'Unesite VAT broj',
    LABEL_VAT_NUMBER: 'VAT broj',
    PLACEHOLDER_ID_NUMBER: 'Unesite ID broj',
    LABEL_ID_NUMBER: 'ID broj',
    CANCEL: 'Poništi',
    SUBMIT: 'Sačuvaj',
};
